import { render, staticRenderFns } from "./MDArea.vue?vue&type=template&id=5491190e&"
import script from "./MDArea.vue?vue&type=script&lang=js&"
export * from "./MDArea.vue?vue&type=script&lang=js&"
import style0 from "./MDArea.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports